import { Pipe, PipeTransform } from '@angular/core';
import { Duration, DurationObject } from 'luxon';

const formatDuration = (duration: number, format: string): string =>
  Duration.fromMillis(duration).toFormat(format);

const formatDurationToString = (duration: number): string => {
  const { hours, minutes } = Duration.fromMillis(duration).shiftTo('hours', 'minutes').toObject();
  const min = hours ? Math.floor(minutes).toString().padStart(2, '0') : Math.floor(minutes);

  return `${hours ?  hours + 'h' : ''}${minutes ?  min + ' min' : ''}`;
};

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {
  transform(duration: number, format: string = 'hh:mm:ss', toString: boolean = false): string {
    const durationInMillis = duration * 1000;
    const hourInMillis = 1000 * 60 * 60;
    if (toString) {
      return duration ? formatDurationToString(durationInMillis) : '0h00 min';
    }
    return duration ? (durationInMillis > hourInMillis
      ? formatDuration(durationInMillis, format)
      : formatDuration(durationInMillis, 'mm:ss')) : '00:00';
  }
}
